import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ModesOfEducation } from '@ascschool/model/category/modes-of-education.model';
import { Modules } from '@ascschool/model/category/modules.model';
import { ModesOfEducationService } from '@ascschool/services/category/modese-of-education.service';
import { ModulesService } from '@ascschool/services/category/modules.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-popup-phan-he',
  templateUrl: './popup-phan-he.component.html',
  styleUrls: ['./popup-phan-he.component.scss']
})
export class PopupPhanHeComponent implements OnInit {
  @Input() value: any;
  isEditMode = false;
  @ViewChild("form", { static: false }) formElement: ElementRef;
  errorMsg: string;
  isDisabled = false;
  validateForm = this.fb.group({
    id: [0],
    typeOfEducationId: [null, [Validators.required]],
    modulesCode: [null, [Validators.required]],
    modulesName: [null, [Validators.required]],
  });
  typeOfEducationControl = this.validateForm.controls.typeOfEducationId;
  modesOfEducation = new ModesOfEducation();
  modules = new Modules();
  getTypeOfEducationACFn: (value: any) => Observable<any>;
  typeOfEducationSubscription: any;
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    private service: ModulesService,
    public utilsService: UtilsService,
    private modeofEducationservice: ModesOfEducationService,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {
    this.loadTypeOfEducation();
    if (this.value && this.value.id > 0) {
      this.GetById(this.value.id);
      this.isEditMode = true;
      this.modesOfEducation.id = this.value.id;
      this.validateForm = this.fb.group({
        id: this.value.id,
        typeOfEducationId: [this.value.typeOfEducationId, [Validators.required]],
        modulesCode: [this.value.modulesCode, [Validators.required]],
        modulesName: [this.value.modulesName, [Validators.required]],
      });
    } else {
      this.isEditMode = false;
    }
  }

  GetById(id: number) {
    this.service.getById(id).subscribe((res: any) => {
      this.modesOfEducation = res;
      if (res.typeOfEducationId) {
        this.modeofEducationservice.getSelectById(res.typeOfEducationId).subscribe(response => {
          this.typeOfEducationControl.setValue({ id: response.id, text: response.name });
        });
      }
    });
  }

  close() {
    this.destroyModal();
  }

  destroyModal(): void {
    this.modal.destroy(true);
  }

  UpdateClose() {
    if (this.validateForm.valid) {
      this.modules = this.validateForm.value;
      this.modules.typeOfEducationId = this.typeOfEducationControl.value.id;
      this.service.addOrUpdate(this.modules).subscribe((res) => {
        if (res.statusCode === 0) {
          this.notification(res);
          this.close();
        } else {
          this.notification(res);
        }
      }, error => {
        this.msg.error('lỗi: ' + error.error.Message);
      });
    } else {
      this.utilsService.findInvalidControlsbyForm(this.validateForm, this.formElement);
    }
  }

  notification(response) {
    if (response.statusCode === 0) {
      this.msg.success('Cập nhật thông tin: ' + response.message);
    } else {
      this.msg.error('Lỗi: ' + response.message);
    }
  }

  loadTypeOfEducation() {
    // tslint:disable-next-line: max-line-length
    this.getTypeOfEducationACFn = (value: any) => this.modeofEducationservice.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.name }))
      : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.typeOfEducationSubscription) {
      this.typeOfEducationSubscription = this.typeOfEducationControl.valueChanges.subscribe(() => {
        this.utilsService.bindOrUnBindTheId(this.modules, 'typeOfEducationId', this.typeOfEducationControl.value);
      });
    }
  }

  changeTypeOfEducation(control: FormControl) {
    if (control.value) {
      this.typeOfEducationControl = control;
    }
  }
}
